import { render, staticRenderFns } from "./TextShimmer.vue?vue&type=template&id=6c1802b8&scoped=true&"
import script from "./TextShimmer.vue?vue&type=script&lang=ts&"
export * from "./TextShimmer.vue?vue&type=script&lang=ts&"
import style0 from "./TextShimmer.vue?vue&type=style&index=0&id=6c1802b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1802b8",
  null
  
)

export default component.exports